import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";

import "./styles.css";

//Components
import { FilterTypes } from "common/features/restaurant/restaurantModels";

//Images
import broccoliActiveIcon from "common/assets/images/filter/active/broccoli.png";
import eggsActiveIcon from "common/assets/images/filter/active/eggs.png";
import flourActiveIcon from "common/assets/images/filter/active/flour.png";
import islamActiveIcon from "common/assets/images/filter/active/islam.png";
import kosherActiveIcon from "common/assets/images/filter/active/kosher.png";

import broccoliInActiveIcon from "common/assets/images/filter/inactive/broccoli.png";
import eggsInActiveIcon from "common/assets/images/filter/inactive/eggs.png";
import flourInActiveIcon from "common/assets/images/filter/inactive/flour.png";
import islamInActiveIcon from "common/assets/images/filter/inactive/islam.png";
import kosherInActiveIcon from "common/assets/images/filter/inactive/kosher.png";

// NPM
import OutsideClickHandler from 'react-outside-click-handler';

type filterKey = keyof FilterTypes;

interface RestaurantHomeFilterProps {
    setIsFiltering: any;
    selectedFilters: any;
    setSelectedFilters: any;

}

function RestaurantHomeFilter(props: RestaurantHomeFilterProps) {

    const handleFilters = (option: any) => {
        let filters = Object.assign({}, props.selectedFilters);
        filters[option] = !filters[option];
        props.setSelectedFilters(filters);
    };

    return (
        <OutsideClickHandler
            onOutsideClick={() => {
                props.setIsFiltering(false);
            }}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%'
            }}>
                <div id="merchant-home-page-modal">
                    <span id="merchant-home-page-modal-row">
                        {Object.keys(props.selectedFilters).map((filter: string) => (
                            <img key={filter}
                                src={
                                    !props.selectedFilters[filter]
                                        ? islamActiveIcon
                                        : islamInActiveIcon
                                }
                                onClick={() => {
                                    handleFilters(filter);
                                }}
                            />
                        ))
                        }
                    </span>
                </div>
            </div>
        </OutsideClickHandler>
    )
}

export default RestaurantHomeFilter;

